import * as actions from './ExecutiveSummaryActions';

const initialState = {
  errors: [],
  executiveSummaryMessage: '',
  isSavingExecutiveSummary: false,
  isDeletingExecutiveSummary: false,
  isEditExecutiveSummaryModalOpen: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.ERRORS_SET:
      return { ...state, errors: payload };
    case actions.IS_SAVING_EXECUTIVE_SUMMARY_SET:
      return { ...state, isSavingExecutiveSummary: payload };
    case actions.IS_DELETING_EXECUTIVE_SUMMARY_SET:
      return { ...state, isDeletingExecutiveSummary: payload };
    case actions.IS_EDIT_EXECUTIVE_SUMMARY_MODAL_OPEN_SET:
      return { ...state, isEditExecutiveSummaryModalOpen: payload };
    case actions.EXECUTIVE_SUMMARY_MESSAGE_SET: {
      return { ...state, executiveSummaryMessage: payload };
    }
    default:
      return state;
  }
};
